module.exports = __webpack_public_path__ + "img/1.8b714f15.png";